// Verkleinert/rekomprimiert ein Bild im Browser, damit der Upload klein bleibt
// (umgeht Größenlimits des Produktions-Servers). Fällt bei Problemen auf das Original zurück.
export async function compressImage(file) {
  if (!file || !file.type?.startsWith("image/")) return file;
  const MAX_DIM = 2200;
  try {
    let bitmap;
    try {
      bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
    } catch {
      bitmap = await createImageBitmap(file);
    }
    const scale = Math.min(1, MAX_DIM / Math.max(bitmap.width, bitmap.height));
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, w, h);
    if (bitmap.close) bitmap.close();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.85));
    if (!blob) return file;
    const name = (file.name || "bild").replace(/\.[^.]+$/, "") + ".jpg";
    const out = new File([blob], name, { type: "image/jpeg" });
    if (file.size <= 1.5 * 1024 * 1024 && file.size < out.size) return file;
    return out;
  } catch {
    return file;
  }
}

// Titel aus Dateinamen ableiten: Endung weg, _ und - zu Leerzeichen, Mehrfach-Spaces weg.
export function titleFromFilename(filename) {
  const base = (filename || "").replace(/\.[^.]+$/, "");
  return base
    .replace(/[_]+/g, " ")
    .replace(/-+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

// Dateinamen auswerten: Titel + erkannte Jahreszahl (1900..nächstes Jahr).
// Die Jahreszahl wird aus dem Titel entfernt und separat zurückgegeben.
export function parseFilename(filename) {
  const base = (filename || "").replace(/\.[^.]+$/, "");
  const spaced = base.replace(/[_\-]+/g, " ").replace(/\s+/g, " ").trim();
  let year = null;
  const matches = spaced.match(/\b(?:19|20)\d{2}\b/g);
  if (matches) {
    const max = new Date().getFullYear() + 1;
    for (let i = matches.length - 1; i >= 0; i--) {
      const y = parseInt(matches[i], 10);
      if (y >= 1900 && y <= max) { year = y; break; }
    }
  }
  let title = spaced;
  if (year != null) {
    title = title.replace(new RegExp(`\\b${year}\\b`), " ").replace(/\s+/g, " ").trim();
  }
  return { title: title || spaced, year };
}
